import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { PUT } from '../common/consts';

// 사진 데이터 목록 가져오기
const getUserPhotoAPI = async (data) => {
  const res = await fetch(`${API_URL}photo?${encodeGetParams(data)}`);
  const result = res.json();
  return result;
};
// 사진 삭제
const deletePhotoAPI = async (data) => {
  const res = await fetch(`${API_URL}photo`, getHeaders(PUT, { ...data }));
  const result = res.json();
  return result;
};
export { getUserPhotoAPI, deletePhotoAPI };
